import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Please do not use this file henceforth
 */
import _set from 'lodash/set';
import _get from 'lodash/get';
import apiService, { getDefaultHeader, getCdmsUrl } from '../services/apiService';
export default (function () {
  var specificUrl = "".concat(getCdmsUrl(), "/");
  var axiosInstance = apiService(specificUrl); // Headers From Local Storage

  var defaultHeaders = getDefaultHeader(); // Headers Specific to Accounting

  var headers = _objectSpread({}, defaultHeaders);

  _set(axiosInstance, 'defaults.headers.common', headers);

  return axiosInstance;
});
export var apiResponseReader = function apiResponseReader(data) {
  return {
    content: apiContentReader(data),
    pageable: apiPageInfo(data),
    sort: apiPageSortInfo(data),
    size: apiPageSize(data),
    additionalInfo: apiAdditionalInfo(data)
  };
};
export var apiContentReader = function apiContentReader(data) {
  return _get(data.data, 'content', []);
};
export var apiPageInfo = function apiPageInfo(data) {
  return _get(data.data, 'pageable', {});
};
export var apiPageSortInfo = function apiPageSortInfo(data) {
  return _get(data.data, 'sort', {});
};
export var apiPageSize = function apiPageSize(data) {
  return _get(data.data, 'sort', {});
};
export var apiAdditionalInfo = function apiAdditionalInfo(data) {
  return {
    totalElements: _get(data.data, 'totalElements', 0),
    totalPages: _get(data.data, 'totalPages', 0),
    numberOfElements: _get(data.data, 'numberOfElements', 0),
    size: _get(data.data, 'size', 0),
    empty: _get(data.data, 'empty', false),
    first: _get(data.data, 'first', true),
    last: _get(data.data, 'last', false),
    number: _get(data.data, 'number', 0)
  };
};
export var isApiError = function isApiError(errorResponse) {
  return !!_get(errorResponse, 'status', '');
};
export var defaultPromise = function defaultPromise(defaultValue) {
  return new Promise(function (resolve) {
    return resolve(defaultValue);
  });
};
export var handleAPISafely = function handleAPISafely(promiseToResolve, onCatchParams) {
  return promiseToResolve.then(function (data) {
    return data;
  })["catch"](function () {
    return onCatchParams;
  });
};